// CONSTANTS are all caps.
const NS = 'PropertyWidget';
const CLS = 'propertyWidget';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/portalProfileDropdown.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class PropertyWidget {
	constructor(el) {
		// $el is the widget node return by the TopStickyNav function
		this.$html = $('html');

		this.$el = $(el);
		this.$showMore = this.$el.find(`#${CLS}ShowMoreRoom`);
		this.$row = this.$el.find(`${WG}row`);
	}

	init() {
		const _that = this;
		this.$showMore.on('click', () => {
			const hiddenCol = this.$row.find('[class*=\'col-\'][data-hidden]');
			this.$showMore.attr('disabled');

			if (hiddenCol !== []) {
				$.when(
					hiddenCol.slice(0, 4).fadeIn().removeAttr('data-hidden')
				).done(() => {
					_that.$showMore.removeAttr('disabled');

					const afterFadeCol = _that.$row.find(
						'[class*=\'col-\'][data-hidden]'
					);

					if (afterFadeCol.length === 0) {
						_that.$showMore.fadeOut('fast', () => {
							_that.$showMore.remove();
						});
					}
				});
			}
		});
	}
}
